export class ResponsiveDisplayConstants {
	public static readonly DEVICE_WIDTH = {
		MOBILE_MAX: 767,
		TABLET_MIN: 768,
		IPAD_AIR: 820,
		TABLET_MAX: 1024,
		DESKTOP_MIN: 1366
	};
}
